import { useQuery } from '@tanstack/react-query';
import { offlineKitApi } from '@/services/offline-kit.api';
import { offlineKitStaleness } from './staleness';

export const OFFLINE_KIT_STATUS_KEY = ['offline-kit-status'];

/**
 * The Offline Kit's status and how stale the last download is.
 *
 * `enabled` is the caller's admin check: the endpoint is admin-only, and only
 * an admin can act on the answer, so nobody else should ask.
 */
export function useOfflineKitStatus(enabled: boolean) {
  const query = useQuery({
    queryKey: OFFLINE_KIT_STATUS_KEY,
    queryFn: offlineKitApi.status,
    enabled,
    retry: false,
    // Ambient state: refreshing it on every focus would be noise, not news.
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    staleness: query.data ? offlineKitStaleness(query.data, new Date()) : null,
  };
}
